/* Because — acquisition LP buy box. Checkout lives in trial-lp.js and skip-trial.js;
   this file only paints two numbers the shopper should see before tapping:
     1. the EXACT monthly renewal for the chosen size, on the trial button's own line
        (the disclosed range until a size is picked);
     2. the 3-pack's price as the delivered total, shipping included. */
(function () {
  'use strict';
  var form = document.getElementById('acquisitionSelector');
  if (!form) return;

  function config(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var skip = config('skiptrial-config');   // Subscribe & Save plan price per variant, qty per delivery
  var three = config('threepack-config');  // retail price per variant, 3-pack discount
  var SHIPPING = 799, FREE_OVER = 7500;
  var shipping = function (cents) { return cents >= FREE_OVER ? 0 : SHIPPING; };
  // data-ship-separate (the clear LP): quote the STORE price and let the page say "+ $7.99
  // shipping" beside it, so each number matches its own line at checkout instead of a
  // delivered total checkout never shows (owner, 2026-09-29).
  var separate = form.hasAttribute('data-ship-separate');
  var billed = function (cents) { return separate ? cents : cents + shipping(cents); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var val = function (name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  };
  var key = function () { return ['gender', 'abs', 'size'].map(val).filter(Boolean).join('|'); };

  // ── What the subscription costs after the trial ──
  // Loop renews on the retail variant, two packs, on the Subscribe & Save plan. The
  // skip-trial snippet emits that plan's live per-delivery price for every variant (the
  // figure its own dialog quotes as "then $X a month"), so this is the same number plus
  // shipping. Falls back to the retail price less the plan's 10% if the snippet is absent.
  var renewalFor = function (k) {
    var packs = (skip && Number(skip.quantity)) || 2;
    var v = skip && skip.variants && skip.variants[k];
    var unit = v ? Number(v.plan) : NaN;
    if (!(unit > 0) && three && three.variants && three.variants[k]) unit = Math.round(Number(three.variants[k].price) * 0.9);
    if (!(unit > 0)) return null;
    var sub = unit * packs;
    return { total: billed(sub) };
  };

  // Queried fresh each time: trial-lp.js rebuilds the button's markup after a refused add.
  var paintRenewal = function () {
    var r = renewalFor(key());
    var out = form.querySelector('[data-acq-renewal]');
    if (!out) return;
    var text = r ? money(r.total) : (out.getAttribute('data-range') || '');
    text = String(text).replace(/&ndash;/g, '\u2013');
    // next-charge v5: bold ONLY the leading $ (data-bold-dollar). Control keeps <b> wrapper.
    // Built as nodes, not innerHTML: data-range is markup text and must stay text.
    if (out.hasAttribute('data-bold-dollar')) {
      out.textContent = '';
      if (text.charAt(0) === '$') {
        var b = document.createElement('b');
        b.textContent = '$';
        out.appendChild(b);
        text = text.slice(1);
      }
      out.appendChild(document.createTextNode(text));
    } else {
      out.textContent = text;
    }
  };

  // ── The 3-pack's price, as the shopper will actually pay it ──
  // trial-lp.js paints "$X one time · save 20%" from the product subtotal; a $7.99 shipping
  // line then appears at checkout — where half of this funnel already abandons. Restate it
  // as the delivered total. Runs after trial-lp.js's own listener (registered earlier), so
  // it always has the last word; "Sold out" is left alone.
  var paintThree = function () {
    var el = document.querySelector('#threePack [data-threepack-price]');
    if (!el || !three || !three.variants) return;
    if (/sold out/i.test(el.textContent)) return;
    var v = three.variants[key()];
    var pct = Number(three.pct) || 0, qty = Number(three.qty) || 3;
    if (!v) { if (el.textContent !== 'One time') el.textContent = 'One time'; return; }
    var unit = Number(v.price);
    var sub = (unit - Math.floor(unit * pct / 100)) * qty;
    // The DELIVERED total, and deliberately no struck price beside it. The button's terms
    // line claims 20%, which is exact against the packs ($65.97 -> $52.80) and wrong
    // against delivered totals, since the same $7.99 shipping sits on both sides and makes
    // the pair 17.8%. Printing an anchor here would put the two numbers that disprove the
    // claim directly beneath it. Anchor and percentage can coexist only if both are on the
    // same basis -- strike the pack prices and state shipping separately.
    if (separate && pct > 0) {
      // Store prices (the clear LP): strike the three packs' regular price beside the 3-pack
      // price. Same basis on both sides, so the "Save 20%" on the terms line is exact
      // (owner, 2026-10-01: "full price crossed, then the new price").
      var html = '<s class="acq-way__was"><span class="skiptrial-sr">Regular price </span>' + money(unit * qty) + '</s> ' + money(sub);
      if (el.innerHTML !== html) el.innerHTML = html;
    } else {
      var txt = money(billed(sub));
      if (el.textContent !== txt) el.textContent = txt;
    }
  };

  var paint = function () { paintRenewal(); paintThree(); };
  form.addEventListener('change', paint);
  // trial-lp.js also paints this label ("$X one time · save 20%") and can do so after us; on
  // the clear LP that text was seen live (2026-10-01). Re-assert ours whenever the label is
  // rewritten — paintThree only writes when the markup differs, so this cannot loop.
  var tp = separate && document.getElementById('threePack');
  if (tp) new MutationObserver(function () { setTimeout(paintThree, 0); })
    .observe(tp, { childList: true, characterData: true, subtree: true });
  window.addEventListener('pageshow', paint);
  paint();
  // trial-lp.js restores both buttons' markup after a refused or failed add, with no change
  // event, which would leave the generic lines behind. Watching only the two buttons (not
  // the document) keeps this from ever looping with another observer.
  form.querySelectorAll('.trial-cta, .threepack-cta').forEach(function (btn) {
    new MutationObserver(function (records) {
      if (records.some(function (m) { return m.addedNodes.length; })) setTimeout(paint, 0);
    }).observe(btn, { childList: true });
  });
})();
